import Body from "./body";
import Header from "./header";

const MyPortfolio = () => {
  return (
    <>
      <Header />
      <Body />
    </>
  );
};

export default MyPortfolio;
